import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled, { withTheme } from 'styled-components';
import { message, Modal, Upload, Divider } from 'antd'
import { Text } from './Text';
import { TextButton, Button } from './Button';
import { Image } from './Image';
import { CardContainer, FlexColumn, Flex } from './Container';
import UploadIcon from '../../Images/upload-cloud.svg'
import environment from '../../environment'
import { ErrorLabel } from './Input'

const { Dragger } = Upload

export const StyledDragger = styled(Dragger)`
    .ant-upload.ant-upload-drag {
        background: #F8F8F9 !important;
        border: 1px dashed #7384AA !important;
        border-radius: 8px !important;
        max-width: 370px;
    }
`;

const LogoModal = ({ edit, aionStore, onUpload, onCancel, onConfirm, loading }) => {
    const [logoUrl, setLogoUrl] = useState(null)
    const [error, setError] = useState(false)

    const uploadProps = {
        action: `${environment.apiBaseUrl}/file/upload`,
        headers: {
            businesskey: aionStore.BusinessUniqueKey,
            type: "logo",
            jwt: aionStore.jwt
        },
        onChange: (info) => {
            var { fileList } = info;
            fileList.forEach(file => {
                const { status, response, name, url } = file;
                console.log("fileList response", response);
                if (status === "done") {
                    onUpload((response.UploadedUrls || [])[0])
                    setLogoUrl((response.UploadedUrls || [])[0])
                    // this.setState({
                    //     logoUrl: (response.UploadedUrls || [])[0],
                    //     showLogoModal: false,
                    // }, () => this.saveLogoUrl());
                }
            });
        }
    };

    var { business } = aionStore
    var { businessInfo } = business.businessProfile || {}
    businessInfo = businessInfo || {}
    const imageUrl = businessInfo.logoUrl

    var imgStyle = { height: 48, width: 48, objectFit: "contain", borderRadius: "5px" }

    return (
        <FlexColumn gap='24px'>
            <FlexColumn start>
                <Text heading>{edit ? 'Edit' : 'Add'} logo</Text>
                <Text margin='0 0 12px'>Logos should be at least 600x600 and will be visible to your team members and optionally visible on invoices.</Text>
            </FlexColumn>

            <Flex start centerHorizontally gap="12px" fullWidth>
                {
                    (logoUrl || imageUrl) && <img src={logoUrl || imageUrl} style={imgStyle} />
                }

                <Text size="16px" weight="500">{(businessInfo.name || "").trim()}</Text>                
            </Flex>

            <FlexColumn start gap='4px' style={{ maxWidth: 370 }}>
                <Text color={'#7384AA'} size='14px' weight={400}>Upload new logo</Text>
                <Flex end fullWidth>
                    <StyledDragger {...uploadProps}>
                        <Flex start center style={{ width: 370, height: 90, maxWidth: 370 }} gap='16px'>
                            <Image src={UploadIcon} width='36px' height='36px' />
                            <FlexColumn start left gap='4px'>
                                <Text size='16px' weight='500'>Drag and drop here or click to upload.</Text>
                                <Text>You may upload PNG or JPEG files</Text>
                            </FlexColumn>
                        </Flex>
                    </StyledDragger>
                </Flex>
                {error && <ErrorLabel>Please upload a logo</ErrorLabel>}
            </FlexColumn>

            <Flex end gap='24px' centerHorizontally>
                <TextButton text='Cancel' onClick={onCancel} />
                <Button text='Confirm' solid primary onClick={() => {
                    if (logoUrl) onConfirm()
                    else setError(true)
                }} loading={loading} />
            </Flex>
        </FlexColumn>
    );
};


function mapStateToProps(state) {
    return {
        aionStore: state.aionAppReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(LogoModal)));
